<template>
  <div>
    <v-card>
      <v-card-text>
        <v-row>
          <v-text-field
            v-model="search"
            label="Search by User ID"
            outlined
            placeholder="Search"
            dense
            class="ml mt"
          ></v-text-field>
        </v-row>
        <v-data-table :headers="headers" :items="users" :search="search" :items-per-page="10" class="usersTable">
          <template v-slot:item="{ item }">
            <tr>
              <v-tooltip left nudge-bottom="40" nudge-left="70" z-index="999" color="black" open-delay="200">
                <template v-slot:activator="{ on }">
                  <td @click="openConfigurationDialog(item.userID)" style="cursor: pointer;" v-on="on">
                    {{ item.userID }}
                  </td>
                </template>
                <span class="tooltiptextRaceNavigation caption"><pre class="tooltipTextRaceNavigationPreformatted">Click to edit</pre></span>
              </v-tooltip>
              <td>
                <v-btn x-small @click="openAPIKeysDialog(item.userID)" fab color="#fe3d89">
                  <v-icon color="white">mdi-account-key</v-icon>
                </v-btn>
              </td>
              <td>
                <!--<v-btn x-small @click="openConfigurationDialog(item)" fab color="#fe3d89">
                  <v-icon color="white">mdi-account-edit</v-icon>
                </v-btn>-->
                <v-btn x-small @click="removeUser(item.userID)" fab color="#425058" style="margin-left: 12px !important;" :disabled="!hasFullControl">
                  <v-icon color="white">mdi-account-minus</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="apiKeysDialog" max-width="685px" persistent>
      <v-card>
        <v-toolbar color="#425058" dark dense>
          <div class="titleBar-content">
            <v-toolbar-title class="raceResults-title">
              API Keys
              <v-btn color="#fe3d89" fab x-small class="ml" style="margin-bottom: 5px;" @click="saveApiKey" :disabled="!hasFullControl">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-toolbar-title>
            <v-btn class="cancelButton" icon small @click="apiKeysDialog = false" ><v-icon class="white--text">mdi-close</v-icon></v-btn>
          </div>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text style="margin-top: 12px;">
          <v-data-table :headers="headersApiKeys" :items="apiKey" hide-default-footer :items-per-page=9999 dense>
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  {{ item.userId }}
                </td>
                <td>
                  {{ item.clientId }}
                </td>
                <td>
                  <v-btn icon @click="removeApiKey(item.clientId)" :disabled="!hasFullControl">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="secretApiKeyDialog" max-width="685px" persistent>
      <v-card>
        <v-toolbar color="#425058" dark dense>
          <div class="titleBar-content">
            <v-toolbar-title class="raceResults-title"> Client Secret </v-toolbar-title>
            <v-btn class="cancelButton" icon small @click="secretApiKeyDialog = false" ><v-icon class="white--text">mdi-close</v-icon></v-btn>
          </div>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div style="margin-top: 15px; font-size: large;">
            {{ secretClient }}
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteUserConfirmation" max-width="300px">
      <v-card>
        <v-toolbar color="#425058" dark dense>
          <div class="titleBar-content">
            <v-toolbar-title class="raceResults-title"> Delete User </v-toolbar-title>
            <v-btn class="cancelButton" icon small @click="deleteUserConfirmation = false" ><v-icon class="white--text">mdi-close</v-icon></v-btn>
          </div>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div style="margin-top: 15px; font-size: large;">
            Are you sure you want to delete <strong>{{ userID }}</strong> ?
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="deleteUserConfirmation = false" small>Cancel</v-btn>
          <v-btn color="success" @click="userDelete" small>Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { accessControlMixin } from './mixins/index'

  export default {
    name: 'ConfigureUser',
    mixins:[accessControlMixin],
    data: () => ({
      search: '',
      items: ['Generate Price Source 1', 'Generate Price Source 2', 'Generate Price Source 3'],
      countriesDialog: false,
      pmClientID: '',
      headers: [
        {
          text: 'User ID',
          value: 'userID'
        },
        {
          text: 'Api Key',
          value: 'apiKey',
          filterable: false,
        },
        {
          text: 'Actions',
          value: 'actions',
          filterable: false,
        }
      ],
      headersApiKeys: [
        {
          text: 'User ID',
          value: 'userId'
        },
        {
          text: 'Client ID',
          value: 'clientId'
        },
        {
          text: 'Actions',
          value: 'actions'
        }
      ],
      selectedCountries: [],
      apiKeysDialog: false,
      userID: null,
      apiKey: [],
      deleteUserConfirmation: false,
      secretApiKeyDialog: false,
      secretClient: ''
    }),
    computed: {
      ...mapGetters(['getUsers','getUserLoggedIn']),
      users () {
        let users = []
        this.getUsers.forEach(u => {
          users.push({ userID: u})
        })
        return users
      },
      hasFullControl(){
        return this.getUserLoggedIn?.roles.includes('*') || this.userHasResourceAccess(this.RESOURCENAMES.API, this.ROLEACTIONCODE.FULL) || this.userHasResourceAccess(this.RESOURCENAMES.MANAGEMENT)
      },
    },
    methods: {
      ...mapActions(['createApiKey', 'getUserKey', 'deleteApiKey', 'getUser', 'deleteUser']),
      openCountriesDialog () {
        this.countriesDialog = true
      },
      async openAPIKeysDialog (userId) {
        this.userID = userId
        this.apiKey = []
        const apiKey = await this.getUserKey({ userID: userId })
        this.apiKey = apiKey
        this.apiKeysDialog = true
      },
      async saveApiKey () {
        const res = await this.createApiKey({ userID: this.userID })
        this.secretClient = res.clientSecret
        const apiKey = await this.getUserKey({ userID: this.userID })
        this.apiKey = apiKey
        this.secretApiKeyDialog = true
      },
      async removeApiKey (clientId) {
        await this.deleteApiKey({ clientID: clientId })
        const apiKey = await this.getUserKey({ userID: this.userID })
        this.apiKey = apiKey
      },
      async openConfigurationDialog (userID) {
        await this.getUser({ userID: userID })
      },
      removeUser (userID) {
        this.userID = userID
        this.deleteUserConfirmation = true
      },
      async userDelete () {
        await this.deleteUser({ userID: this.userID })
        this.deleteUserConfirmation = false
        this.userID = ''
      }
    }
  }
</script>

<style>
  .ml {
    margin-left: 12px !important;
  }

  .msl-search-list-input {
    pointer-events: none;
    font-weight: bold;
  }

  .msl-searchable-list__items {
    border-radius: 5px;
    width: 300px;
  }

  .usersTable {
    height: 1067px;
  }

  @media (max-height: 1264px) {
    .usersTable {
      height: 697px;
    }
  }
</style>
